{
    "title": "Customers",
    "board":{
        "id": "ID",
        "name": "Name",
        "status": "Status",
        "type": "Type",
        "country": "Country"
    },
    "menu": {
        "title": "Admin Panel",
        "customers": "Customers",
        "transactions": "Transactions",
        "counterparties": "Counterparties",
        "applications": "Applications"
    },
    "applicationtype": {
        "corporation": "CORPORATION",
        "individual": "INDIVIDUAL"
    }
}